import { useEffect, useRef, useState } from 'react';

const testimonials = [
  {
    quote: 'GAME CHANGER',
    sub: 'Syntera transformed our legacy system into a modern cloud platform in just 3 months.',
    name: 'Marcus T.',
    role: 'CTO, FinTech startup',
    color: '#FA6E4F',
  },
  {
    quote: 'PURE QUALITY',
    sub: 'Their marketing strategy doubled our lead generation within the first quarter.',
    name: 'Sarah K.',
    role: 'Marketing Director',
    color: '#8EC9BB',
  },
  {
    quote: 'TOP NOTCH',
    sub: 'Professional team, transparent process, and results that exceeded expectations.',
    name: 'Yuki L.',
    role: 'Founder, E-commerce brand',
    color: '#FB8E7E',
  },
];

export default function TestimonialsSection() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const prev = () => setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent((c) => (c + 1) % testimonials.length);
  const t = testimonials[current];

  return (
    <section ref={ref} className="w-full h-screen flex flex-col overflow-hidden relative">
      {/* Split background */}
      <div className="absolute inset-0 flex flex-col">
        <div className="h-2/5 w-full" style={{ background: '#C5D7C0' }} />
        <div className="h-3/5 w-full" style={{ background: '#F8CA9D' }} />
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-8">
        <div
          className={`w-full max-w-4xl transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'}`}
        >
          {/* Card */}
          <div
            className="rounded-[40px] p-16 relative overflow-hidden"
            style={{ background: '#fff' }}
          >
            {/* Icon */}
            <div className="flex justify-center mb-8">
              <div className="w-16 h-16 flex items-center justify-center rounded-full" style={{ background: t.color + '20' }}>
                <i className="ri-chat-quote-line text-3xl" style={{ color: t.color }} />
              </div>
            </div>

            {/* Quote */}
            <div
              className="text-center transition-all duration-500"
              key={current}
            >
              <p
                className="boldonse leading-none mb-6"
                style={{ fontSize: 'clamp(48px, 8vw, 100px)', color: t.color }}
              >
                {t.quote}
              </p>
              <p className="text-gray-500 text-xl mb-8">{t.sub}</p>
              <div className="flex items-center justify-center gap-3">
                <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: t.color }}>
                  <i className="ri-user-line text-white text-sm" />
                </div>
                <div className="text-left">
                  <p className="font-semibold text-gray-800">{t.name}</p>
                  <p className="text-gray-400 text-sm">{t.role}</p>
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="absolute bottom-8 right-8 flex gap-3">
              <button
                onClick={prev}
                className="w-12 h-12 rounded-full flex items-center justify-center border-2 transition-all duration-300 hover:scale-110 cursor-pointer whitespace-nowrap"
                style={{ borderColor: t.color, color: t.color }}
              >
                <i className="ri-arrow-left-line" />
              </button>
              <button
                onClick={next}
                className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer whitespace-nowrap"
                style={{ background: t.color, color: '#fff' }}
              >
                <i className="ri-arrow-right-line" />
              </button>
            </div>

            {/* Dots */}
            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className="rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
                  style={{
                    width: i === current ? '24px' : '8px',
                    height: '8px',
                    background: i === current ? t.color : '#ddd',
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
